<template>
    <div v-if="!loading">
        <template v-if="!marshal">
            <b-row>
                <div class="col-sm-12">
                    <b-card>
                        <b-card-title title-tag="h6" title="Marshals"></b-card-title>
                        <b-card-body>
                            <table class="table table-bordered table-striped">
                                <thead>
                                    <tr>
                                        <th>Marshal</th>
                                        <th>Previous Month - {{ previousMonth() }}</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="marsh in marshals" :key="marsh.id">
                                        <td>{{ marsh.name }}</td>
                                        <td>
                                            <template v-if="marsh.counts">{{ marsh.counts.total }} Total / {{ marsh.counts.show }} show / {{ marsh.counts.noShow }} no show</template>
                                            <template v-else>Loading Data</template>
                                        </td>
                                        <td>
                                            <b-button type="button" variant="primary" @click="viewMarshal(marsh)"><i class="fas fa-fw fa-eye"></i> View</b-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </b-card-body>
                    </b-card>
                </div>
            </b-row>
        </template>
        <marshal-booking-view v-else :marshalRaw="marshal"></marshal-booking-view>
    </div>
</template>

<script>
export default {
    data() {
        return {
            users: [],
            marshal: false,
            loading: false,
        }
    },
    computed: {
        marshals() {
            // Filter out users that are not marshals
            return this.users.filter(user => user.level === 'Marshal');
        },
    },
    methods: {
        viewMarshal(marshal) {
            this.marshal = marshal;
        },
        previousMonth() {
            // Get the previous month and return Month name as string
            var date = new Date();
            date.setMonth(date.getMonth() - 1);
            return date.toLocaleString('default', { month: 'long' });
        },
        init() {
            // Load users using axios.get with the route this.$routes.route('user.index')
            // When the data is loaded then for each user get the marshal booking count using axios.get and the route this.$routes.route('marshalbooking.count', {user: user.id})
            // When the data is loaded then set the user.counts to the response.data
            // then set this.users to the response.data
            // finally set this.loading to false

            var userCount = 0;
            var dataCount = 0;
            axios.get(this.$routes.route('user.index'))
                .then(response => {
                    this.users = response.data;
                    userCount = this.users.length;
                    this.users.forEach(user => {
                        axios.get(this.$routes.route('marshalbooking.count', {user: user.id}))
                            .then(response => {
                                user.counts = response.data;
                                dataCount++;
                            });
                    });

                    var interval = setInterval(() => {
                        if (userCount === dataCount) {
                            clearInterval(interval);
                            this.loading = false;
                        }
                    }, 100);
                });
        },
    },
    mounted() {
        this.loading = true;
        this.init();
    },
}
</script>